import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionBackgroundProps {
  children: ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'dark';
}

export function SectionBackground({
  children,
  className,
  variant = 'primary',
}: SectionBackgroundProps) {
  return (
    <div
      className={cn(
        'rounded-2xl border-4 border-[#8BC34A] overflow-hidden transition-all duration-300',
        variant === 'primary' && 'bg-green-950/40 backdrop-blur-sm',
        variant === 'secondary' && 'bg-green-900/30 backdrop-blur-sm',
        variant === 'dark' && 'bg-black/40 backdrop-blur-sm',
        className,
      )}
    >
      {children}
    </div>
  );
}
